import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getToken, deleteToken, deleteuser } from "../helpers/utils/auth.util";

const ProtectedRoute = ({ children }) => {
  const token = getToken();
  const [authState, setAuthState] = useState("loading"); // "loading" | "valid" | "invalid"

  useEffect(() => {
    if (!token) {
      setAuthState("invalid");
      return;
    }

    // Validate token with backend to ensure it's not expired
    const apiBase = process.env.REACT_APP_API_URL || "";
    fetch(`${apiBase}/auth/me`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          setAuthState("valid");
        } else {
          // Token is invalid or expired — clear local storage
          deleteToken();
          deleteuser();
          setAuthState("invalid");
        }
      })
      .catch(() => {
        // Network error — allow access if token exists (offline-safe fallback)
        setAuthState("valid");
      });
  }, [token]);

  if (authState === "loading") return null; // Or a spinner
  if (authState === "valid") return children;
  return <Navigate to="/login" />;
};

export default ProtectedRoute;
